<div class="product-features-table grid align-center padding-horizontal-medium padding-bottom-medium padding-vertical-xbig">
  <div class="cell cell-large-col-span-12 text-center">
    <h1 class="display-small text-center">{{ data.settings?.heading }}</h1>
    <p class="text-large margin-top-small margin-bottom-none" [innerHTML]="data.settings?.subtext"></p>
    <mat-tab-group mat-align-tabs="center" mat-stretch-tabs="false" class="margin-top-medium">
      <mat-tab *ngFor="let tab of data.settings?.tableData" [label]="tab.tabLabel">
        <div class="product-features-table">
          <div class="grid align-center padding-horizontal-medium padding-vertical-small text-left font-bold" *ngFor="let items of tab.table; index as itemIndex">
            <ng-container *ngFor="let cell of items; index as i">
              <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-6" [ngClass]="{'cell-small-col-span-6': i === 0}">
                <mat-icon [class]="cell?.icon" [ngStyle]="{'color': cell?.colour}" aria-hidden="false"></mat-icon>
                <p [ngClass]="{'xsmall': i !== 0 && itemIndex !== 0}" [innerHTML]="cell?.label"></p>
              </div>
            </ng-container>
          </div>
          <div *ngIf="tab.footer" class="product-features-table-footer grid align-center padding-top-medium text-left font-bold">
            <div class="cell cell-large-col-span-12">
              <span class="text-xsmall" [innerHTML]="tab.footer"></span>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <p class="text-large margin-top-small" [innerHTML]="data.settings?.terms"></p>
  </div>
</div>